'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosListOutline = function IoIosListOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.8 6.3h-27.5v27.5h27.5v-27.5z m1.2-1.3v30h-30v-30h30z m-20 8.1v-1.2h15v1.2h-15z m0 7.5v-1.2h15v1.2h-15z m0 7.5v-1.2h15v1.2h-15z m-5-15.6c0-0.9 0.4-1.2 1.3-1.2s1.2 0.3 1.2 1.2-0.4 1.3-1.2 1.3-1.3-0.4-1.3-1.3z m0 7.5c0-0.9 0.4-1.2 1.3-1.2s1.2 0.3 1.2 1.2-0.4 1.3-1.2 1.3-1.3-0.4-1.3-1.3z m0 7.5c0-0.9 0.4-1.2 1.3-1.2s1.2 0.3 1.2 1.2-0.4 1.3-1.2 1.3-1.3-0.4-1.3-1.3z' })
        )
    );
};

exports.default = IoIosListOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-list-outline.js
// module id = 2224
// module chunks = 0